var _rect, _circle, _circle2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#DEF1EB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 19,
    r: 4,
    fill: "#54BB9C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 19,
    r: 4,
    stroke: "#014935",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 33V31C15 28.7909 16.7909 27 19 27H23C25.2091 27 27 28.7909 27 31V33",
    stroke: "#014935",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 22C27.4477 22 27 22.4477 27 23C27 23.5523 27.4477 24 28 24V22ZM34 24C34.5523 24 35 23.5523 35 23C35 22.4477 34.5523 22 34 22V24ZM32 20C32 19.4477 31.5523 19 31 19C30.4477 19 30 19.4477 30 20H32ZM30 26C30 26.5523 30.4477 27 31 27C31.5523 27 32 26.5523 32 26H30ZM28 24H34V22H28V24ZM30 20V26H32V20H30Z",
    fill: "#014935"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlusIcon);
export default __webpack_public_path__ + "static/media/user-plus-icon.204d8d2474d5d1a999e966a91275488c.svg";
export { ForwardRef as ReactComponent };